import { useSelector } from 'react-redux';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { EntityFileDetails } from 'components/shared/EntityFileDetails';
import { Divider } from '@mui/material';
import { LocalMallOutlined } from '@mui/icons-material';

export const QuoteProductDetails = () => {
  const selectedQuoteProduct = useSelector((state) => state.marketplace.selectedQuoteProduct.value);
  const { category, supplier, product_name, product_description, price } = selectedQuoteProduct;

  return (
    <DrawerContent>
      <DrawerContent.Header title={product_name} />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <EntityFileDetails>
            <EntityFileDetails.FileType
              file={selectedQuoteProduct}
              fileIcon={<LocalMallOutlined sx={{ fontSize: '100px' }} />}
            />
            <Divider />
            <EntityFileDetails.Details title="Product Details">
              {product_name && (
                <EntityFileDetails.DetailsItem
                  title="Product Name"
                  subtitle={product_name}
                />
              )}
              {category?.name && (
                <EntityFileDetails.DetailsItem
                  title="Category"
                  subtitle={category?.name}
                />
              )}
              {supplier?.name && (
                <EntityFileDetails.DetailsItem
                  title="Supplier"
                  subtitle={supplier?.name}
                />
              )}
              {price && (
                <EntityFileDetails.DetailsItem
                  title="Price"
                  subtitle={`$${price}`}
                />
              )}
              {product_description && (
                <EntityFileDetails.DetailExpandableText
                  title="Product Description"
                  text={product_description}
                />
              )}
            </EntityFileDetails.Details>
          </EntityFileDetails>
        </DrawerContent.Content>
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
